import React from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import Button from "../../../../../../components/common/PL/Button/Button";
import PicturePreview from "../../../../../../components/common/PL/PicturePreview/PicturePreview";
import { GateControlItem, GateControlObservation } from "./transportAuthorizationTypes";

const OBSERVACION_MAX_LENGTH = 500;

type VerificarControlRowProps = {
  control: GateControlItem;
  observation?: GateControlObservation;
  isExpanded: boolean;
  onToggleExpand: () => void;
  onVerificar: () => void;
  onObservacionTextChange: (text: string) => void;
  onObservacionPhotoChange: (photo: File | null) => void;
};

const VerificarControlRow: React.FC<VerificarControlRowProps> = ({
  control,
  observation,
  isExpanded,
  onToggleExpand,
  onVerificar,
  onObservacionTextChange,
  onObservacionPhotoChange,
}) => {
  const observacionText = observation?.text ?? "";
  const observacionPhoto = observation?.photo ?? null;

  // PicturePreview quiere una URL para previsualizar; el estado levantado sólo guarda el File
  // (para el futuro endpoint de subida), así que la URL se deriva acá y se libera al cambiar.
  const [photoPreviewUrl, setPhotoPreviewUrl] = React.useState<string>("");
  React.useEffect(() => {
    if (!observacionPhoto) {
      setPhotoPreviewUrl("");
      return undefined;
    }
    const url = URL.createObjectURL(observacionPhoto);
    setPhotoPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [observacionPhoto]);

  return (
    <div className="verificarControlesEgresoModalRowGroup">
      <div className="verificarControlesEgresoModalRow">
        <div className="verificarControlesEgresoModalRowInfo">
          <span className="verificarControlesEgresoModalRowLabel">{control.label}</span>
          {control.value && (
            <span className="verificarControlesEgresoModalRowNumero">{control.value}</span>
          )}
          {control.valueSecondary && (
            <span className="verificarControlesEgresoModalRowNumero">{control.valueSecondary}</span>
          )}
        </div>
        <div className="verificarControlesEgresoModalRowActions">
          <Button
            variant="outline"
            size="small"
            onClick={onToggleExpand}
            className="verificarControlesEgresoModalObservacionButton"
          >
            Observación
          </Button>
          {control.verified ? (
            <Button
              variant="success"
              size="small"
              onClick={onVerificar}
              className="verificarControlesEgresoModalVerifyButton"
            >
              <CheckCircleIcon fontSize="small" style={{ marginRight: 4 }} />
              Verificado
            </Button>
          ) : (
            <Button
              variant="outline"
              size="small"
              onClick={onVerificar}
              className="verificarControlesEgresoModalVerifyButton"
            >
              Verificar
            </Button>
          )}
        </div>
      </div>

      <div
        className={`verificarControlesEgresoModalObservacionAccordion ${isExpanded ? "open" : ""}`}
      >
        <div className="verificarControlesEgresoModalObservacionAccordionInner">
          <textarea
            className="verificarControlesEgresoModalObservacionTextArea"
            value={observacionText}
            onChange={(e) =>
              onObservacionTextChange(e.target.value.slice(0, OBSERVACION_MAX_LENGTH))
            }
            placeholder="-completar-"
            rows={2}
          />
          <span className="verificarControlesEgresoModalObservacionCounter">
            {observacionText.length}/{OBSERVACION_MAX_LENGTH}
          </span>

          <div className="verificarControlesEgresoModalObservacionPhotoWrapper">
            <PicturePreview
              imageUrl={photoPreviewUrl}
              onUpload={(file) => onObservacionPhotoChange(file)}
              label="Agregar foto"
              allowClear
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificarControlRow;
